import { createFileRoute } from "@tanstack/react-router";

import { OrganizationSettingsPage } from "src/pages/OrganizationSettingsPage";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/settings/")({
  component: OrganizationSettingsPage,
  ssr: true,
});
